const applyPopup = () => {
  const popup = document.querySelector('.js-apply-popup');

  if (popup) {
    const buttons = document.querySelectorAll('.js-apply-button');
    const mode = document.querySelector('.js-apply-mode select');
    const language = document.querySelector('.js-apply-language select');
    const close = document.querySelector('.js-apply-close');
    const link = document.querySelector('.js-apply-link');
    let { urls } = document.querySelector('.js-apply-data').dataset;
    urls = JSON.parse(urls);
    let modeValue = null;
    let languageValue = null;

    const validForLink = () => {
      if (modeValue && languageValue) {
        link.classList.remove('c-button--disabled');
        urls.forEach(el => {
          if (
            el.major_apply_online_mode[0].name === modeValue &&
            el.major_apply_online_language[0].name.replace(/\s+/g, '') ===
              languageValue
          ) {
            link.href = el.major_apply_online_link;
          }
        });
      } else {
        link.classList.add('c-button--disabled');
      }
    };

    const checkLanguageSelect = () => {
      language.parentNode.querySelectorAll('.c-select__item').forEach(item => {
        item.classList.add('u-hidden');
        urls.forEach(el => {
          if (
            el.major_apply_online_mode[0].name === modeValue &&
            el.major_apply_online_language[0].name === item.textContent
          ) {
            item.classList.remove('u-hidden');
          }
        });
      });
    };

    buttons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        popup.classList.remove('u-hidden');
      });
    });

    mode.addEventListener('change', () => {
      const value = mode
        .querySelector(`option[value="${mode.value}"]`)
        .textContent.replace(/\s+/g, '');
      modeValue = value;
      document.querySelector(
        '.js-apply-language .c-select__title',
      ).textContent = language.querySelector('option').textContent;
      languageValue = null;
      checkLanguageSelect();
      validForLink();
    });

    language.addEventListener('change', () => {
      const value = language
        .querySelector(`option[value="${language.value}"]`)
        .textContent.replace(/\s+/g, '');
      languageValue = value;
      validForLink();
    });

    close.addEventListener('click', () => {
      popup.classList.add('u-hidden');
    });
  }
};

export default applyPopup;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/applyPopup.js